// src/utils/tiktok.js
export const trackTikTokEvent = (eventName, eventData = {}) => {
    if (typeof window !== "undefined" && window.ttq) {
        window.ttq.track(eventName, eventData);
        console.log(`TikTok Event Tracked: ${eventName}`, eventData);
    } else {
        console.warn("TikTok Pixel not initialized yet");
    }
};
